export const sizes = {
    sm: 20,
    md: 30, // MUI default
    lg: 44,
    xl: 48,
    xxl: 64,
};
export type AvatarSize = keyof typeof sizes;
